import { render } from "./ShipmentTable.vue?vue&type=template&id=29f1d339&scoped=true"
import script from "./ShipmentTable.vue?vue&type=script&lang=js"
export * from "./ShipmentTable.vue?vue&type=script&lang=js"

import "./ShipmentTable.vue?vue&type=style&index=0&id=29f1d339&scoped=true&lang=css"

import exportComponent from "C:\\Users\\blake\\LREX-site\\lrex-site\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29f1d339"]])

export default __exports__